// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"92a48b36","455":"cc8c73d8","977":"062eaf69"}[chunkId] + ".chunk.js";
};